import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from 'src/app/redux/store';
import { finalUrlsConfig } from 'src/configs/url.config';

export const surferApiSlice = createApi({
  reducerPath: 'surferApi',
  baseQuery: async (args, api, extraOptions) => {
    const dynamicBaseUrl = finalUrlsConfig().surferURL;

    const rawBaseQuery = fetchBaseQuery({
      baseUrl: dynamicBaseUrl,
      prepareHeaders: (headers, { getState }) => {
        const { token } = (getState() as RootState).user;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      },
    });
    return rawBaseQuery(args, api, extraOptions);
  },
  // baseQuery: fetchBaseQuery({
  //   baseUrl: finalUrlsConfig().surferURL,
  //   prepareHeaders: (headers, { getState }) => {
  //     const { token } = (getState() as RootState).user;
  //     if (token) {
  //       headers.set('Authorization', `Bearer ${token}`);
  //     }
  //     return headers;
  //   },
  // }),
  tagTypes: ['NSearch'],
  endpoints: () => ({}),
});
